import "core-js/modules/es.object.from-entries.js";
import { __spreadArray as r } from "tslib";
import "../../types/authenticator/user.js";
import { authFieldsWithDefaults as t } from "../../types/authenticator/attributes.js";
import "../../types/primitives/componentClassName.js";
var n = function n(r) {
    var t = new FormData(r.target);
    return Object.fromEntries(t);
  },
  e = function e(t, n) {
    var e = [];
    return t && (e = Object.keys(t).reduce(function (r, n) {
      var e;
      return r.push([n, null === (e = t[n]) || void 0 === e ? void 0 : e.order]), r;
    }, []).sort(function (r, t) {
      return r[1] - t[1];
    }).filter(function (r) {
      return void 0 !== r[1];
    }).map(function (r) {
      return r[0];
    })), Array.from(new Set(r(r([], e, !0), n, !0)));
  },
  o = function o(r) {
    return t.includes(r);
  },
  i = function i(r) {
    return r ? (t = r, Array.isArray(t) ? r : [r]) : null;
    var t;
  };
export { i as getErrors, n as getFormDataFromEvent, o as isAuthFieldWithDefaults, e as setFormOrder };